import React, { useState } from 'react';
import API_BASE_URL from "../../../apiConfig";
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

const AddApplicants = () => {
  const [formItems, setFormItems] = useState([{}]);

  const organizationName = localStorage.getItem("organizationName") || "";
  const organizerContactNo = localStorage.getItem("organizerContactNo") || "";

  const handleAddClick = () => {
    setFormItems([...formItems, {}]);
  };

  const [formData, setFormData] = useState({
    organizerContactNo: '',
    applicantName: '',
    contactNo: '',
    dob: '',
    organizationName: '',
    services: [],
  });

  const servicesOptions = [
    'PAN',
    'ELECTION CARD',
    'PM Kisan KYC',
    'E Sharam Card',
    'PM Ayushman Bharat Card',
    'Aadhar',
    'Other',
  ];

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleItemChange = (index, e) => {
    const { name, value } = e.target;
    const updatedItems = [...formItems];
    updatedItems[index][name] = value;
    setFormItems(updatedItems);
  };

  const handleItemServiceChange = (index, e) => {
    const { value, checked } = e.target;
    const updatedItems = [...formItems];
    const currentServices = updatedItems[index].services || [];

    updatedItems[index].services = checked
      ? [...currentServices, value]
      : currentServices.filter((s) => s !== value);

    setFormItems(updatedItems);
  };

  const formatDateToString = (dob) => {
    if (!dob) return "";
    const options = { day: "2-digit", month: "2-digit", year: "numeric" };
    return new Intl.DateTimeFormat("en-GB", options).format(new Date(dob)); // Format: dd/MM/yyyy
  };

  const [registrationNo, setRegistrationNo] = useState("");
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [successMsg, setSuccessMsg] = useState(""); // Add this state

  const submitApplicants = async () => {
    const apiEndpoint = `${API_BASE_URL}/CampRegistration/AddCampApplicants`;
    const campRegistrationId = localStorage.getItem("campRegistrationId");
    if (!campRegistrationId) {
      alert("Camp Registration ID not found.");
      return;
    }

    const payload = {
      CampRegistrationId: parseInt(campRegistrationId),
      Applicants: formItems.map((item) => ({
        ApplicantName: item.applicantName,
        Services: item.services,
        DateOfBirth: formatDateToString(item.dob),
        ContactNo: item.contactNo,
      })),
    };

    const authToken = localStorage.getItem("authToken");

    try {
      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        const result = await response.json();
        setRegistrationNo(result.registrationNo);
        console.log("Registration successful:", result);
        generatePDF(result.registrationNo);
        setFormItems([{ applicantName: "", dob: "", contactNo: "", services: [] }]);
      } else {
        const error = await response.json();
        alert(error.message || "Failed to register applicants.");
      }
    } catch (error) {
      console.error("Error during registration:", error);
      alert("An error occurred while submitting applicants.");
    }
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   setShowConfirmModal(true);

  //   const apiEndpoint =
  //    // "http://localhost:5121/api/CampRegistration/AddCampApplicants"; // Update with actual API URL
  //       "https://apiv2.chakran.in/api/CampRegistration/AddCampApplicants";

  //     const campRegistrationId = localStorage.getItem("campRegistrationId"); // ⬅️ Assuming this is stored previously
  //     console.log(campRegistrationId);
  //     if (!campRegistrationId) {
  //       alert("Camp Registration ID not found.");
  //       return;
  //     }

  //    const payload = {    
  //     CampRegistrationId: parseInt(campRegistrationId),  
  //      Applicants: formItems.map((item) => ({
  //        ApplicantName: item.applicantName,
  //        Services: item.services,
  //        DateOfBirth: formatDateToString(item.dob),
  //       ContactNo : item.contactNo,
  //      })),
  //    };

  //    const authToken = localStorage.getItem("authToken");

  //    try {
  //      const response = await fetch(apiEndpoint, {
  //        method: "POST",
  //        headers: {
  //          "Content-Type": "application/json",
  //           Authorization: `Bearer ${authToken}`,
  //        },
  //        body: JSON.stringify(payload),
  //      });

  //      if (response.ok) {
  //        const result = await response.json();
  //        setRegistrationNo(result.registrationNo); // Save registration no from response
  //        console.log("Registration successful:", result);
  //        generatePDF(result.registrationNo); // Generate PDF with Registration No
  //        setFormItems([{ applicantName: "", dob:"", contactNo:"", services: [] }]);
  //      } else {
  //       const error = await response.json();
  //       alert(error.message || "Failed to register applicants.");

  //     }

  //    } catch (error) {
  //     console.error("Error during registration:", error);
  //     alert("An error occurred while submitting applicants.");
  //     }
  // };

  const handleConfirm = async () => {
    setShowConfirmModal(false);
    await submitApplicants();
    setSuccessMsg("Applicants submitted successfully! PDF downloaded."); // Show success message
  };

  const handleStay = () => {
    setShowConfirmModal(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowConfirmModal(true);
  };
  const generatePDF = () => {
    const registrationNo = localStorage.getItem("campRegistrationNo") || 'N/A';

    formItems.forEach((item, index) => {
      const doc = new jsPDF();

      const drawReceipt = (yOffset) => {
        doc.setLineWidth(0.3);
        doc.rect(5, yOffset, 200, 135); // X, Y, Width, Height

        // Heading
        doc.setFontSize(20);
        doc.setFont('helvetica', 'bold');
        doc.text('CHAKRAN MULTI SERVICES PVT LTD', 105, yOffset + 10, { align: 'center' });

        doc.setFontSize(17);
        doc.text('Camp Registration Receipt', 105, yOffset + 22, { align: 'center' });

        doc.setLineWidth(0.3);
        doc.line(10, yOffset + 15, 200, yOffset + 15);
        doc.line(10, yOffset + 25, 200, yOffset + 25);

        // Content
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(10);

        doc.text(`Registration No.: ${registrationNo || 'N/A'}`, 10, yOffset + 35);
        doc.text(`Date: ${new Date().toLocaleDateString()}`, 150, yOffset + 35);

        doc.text('Organization Name:', 10, yOffset + 45);
        doc.text(organizationName || 'N/A', 60, yOffset + 45);

        doc.text('Organization Number:', 10, yOffset + 55);
        doc.text(organizerContactNo || 'N/A', 60, yOffset + 55);

        doc.text('Applicant Name:', 10, yOffset + 65);
        doc.text(item.applicantName || 'N/A', 60, yOffset + 65);

        doc.text('Contact No.:', 10, yOffset + 75);
        doc.text(item.contactNo || 'N/A', 60, yOffset + 75);

        doc.text('Date of Birth:', 10, yOffset + 85);
        doc.text(formatDateToString(item.dob) || 'N/A', 60, yOffset + 85);

        doc.setFont('helvetica', 'bold');
        doc.text('Services:', 120, yOffset + 45);

        doc.setFont('helvetica', 'normal');
        item.services?.forEach((service, sIdx) => {
          doc.text(service, 120, yOffset + 65 + sIdx * 10);
        });

        // Office Details
        doc.setFont('helvetica', 'bold');
        doc.text('Office Address:', 10, yOffset + 100);
        doc.setFont('helvetica', 'normal');
        doc.text(
          'Shop No.5, Shanti Nagar Dongari, Near Canara Bank,\nS V Road, Dahisar East, Mumbai - 400068',
          10,
          yOffset + 105
        );

        doc.setFont('helvetica', 'bold');
        doc.text('Contact:', 10, yOffset + 120);
        doc.setFont('helvetica', 'normal');
        doc.text('Mobile No.: 9967318555', 10, yOffset + 125);
        doc.text('Email Id: support@chakran.in', 10, yOffset + 130);

        doc.setFontSize(10);
        doc.text('For, CHAKRAN MULTI SERVICES PVT LTD', 120, yOffset + 110);
        doc.text('Authorized Signatory', 140, yOffset + 130);
      };

      // First page
      drawReceipt(10);

      // Dotted line separator
      doc.setLineDash([3, 3], 0);
      doc.line(10, 153, 200, 153);
      doc.setLineDash([], 0);

      // Second page with copy
      //doc.addPage();
      drawReceipt(160);

      // Save PDF with unique name
      const safeName = item.applicantName?.replace(/\s+/g, '_') || `applicant${index + 1}`;
      doc.save(`camp-receipt-${registrationNo}-${safeName}.pdf`);
    });
  };

  return (
    <div className="kids-avenue-font">
      <div className="row">
        <div className="col-xl-12">
          {/* Ensure onSubmit is inside form */}
          <form onSubmit={handleSubmit}>
            <div className="card card-default">
              <div className="card-body">
                <div className="row">
                  <div className="form-group col-md-4">
                    <label htmlFor="AreaCode">CAMP ORGANIZER NAME</label>
                    <input
                      type="text"
                      className="form-control"
                      value={organizationName}
                      readOnly
                    />
                  </div>
                  <div className="form-group col-md-4">
                    <label htmlFor="AreaCode">ORGANIZER CONTACT NO.</label>
                    <input
                      type="text"
                      className="form-control"
                      value={organizerContactNo}
                      readOnly
                    />
                  </div>
                </div>

                {/* Render the dynamic input fields */}
                {formItems.map((item, index) => (
                  <div key={index} className="row">
                    <div className="form-group col-md-4">
                      <label htmlFor="AONo">APPLICANT NAME</label>
                      <input
                        type="text"
                        className="form-control"
                        name="applicantName"
                        placeholder="ENTER APPLICANT NAME"
                        value={item.applicantName || ""}
                        onChange={(e) => handleItemChange(index, e)}
                      />
                    </div>

                    <div className="form-group col-md-4">
                      <label htmlFor="AONo">DATE OF BIRTH</label>
                      <input
                        type="date"
                        className="form-control"
                        data-mask="00/00/0000"
                        name="dob"
                        value={item.dob || ""}
                        onChange={(e) => handleItemChange(index, e)}
                      />
                      <p style={{ fontSize: '90%' }}>EX. 99/99/9999</p>
                    </div>
                    <div className="form-group col-md-4">
                      <label htmlFor="AONo">CONTACT NO</label>
                      <div className="input-group mb-3">
                        <div className="input-group-prepend">
                          <span className="input-group-text mdi mdi-phone"></span>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          data-mask="(999) 999-9999"
                          placeholder="MOBILE NO"
                          name="contactNo"
                          value={item.contactNo || ""}
                          onChange={(e) => handleItemChange(index, e)}
                        />
                      </div>
                    </div>
                    <div className="form-group col-md-8">
                      <label htmlFor="AONo">SERVICE</label><br />
                      {servicesOptions.map((service, idx) => (
                        <div key={idx} className="checkboxleft">
                          <input
                            type="checkbox"
                            value={service}
                            checked={item.services?.includes(service) || false}
                            onChange={(e) => handleItemServiceChange(index, e)}
                          />
                          <label>{service}</label>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
                <button
                  type="button"
                  className="btn btn-primary btn-pill"
                  onClick={handleAddClick}
                >
                  + ADD APPLICANT
                </button>
                <div className="form-footer pt-2">
                  <button type="submit" className="btn btn-primary btn-pill">
                    SUBMIT
                  </button>
                </div>
              </div>
            </div>
          </form>
          {showConfirmModal && (
            <div className="modal-backdrop" style={{
              position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
              background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999
            }}>
              <div style={{
                background: "#fff", padding: 24, borderRadius: 8, minWidth: 300, textAlign: "center"
              }}>
                <h5>DO YOU WANT TO SUBMIT?</h5>
                <p>PRESS CONFIRM TO SUBMIT OR STAY TO REMAIN ON THIS PAGE.</p>
                <button className="btn btn-secondary mr-2" onClick={handleStay}>STAY</button>
                <button className="btn btn-primary" onClick={handleConfirm}>CONFIRM</button>
              </div>
            </div>
          )}
          {successMsg && (
            <div className="alert alert-success mt-3" role="alert">
              {successMsg}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddApplicants;


// import React, { useState } from 'react';
// import { jsPDF } from 'jspdf';
// import 'jspdf-autotable';

// const AddApplicants = () => {
//   const [formItems, setFormItems] = useState([{}]);

//   const handleAddClick = () => {
//     setFormItems([...formItems, {}]);
//   };

//   const [formData, setFormData] = useState({
//     registrationNo: '',
//     applicantName: '',
//     contactNo: '',
//     dob: '',
//     organizationName: '',
//     services: [],
//   });

//   const servicesOptions = [
//     'PAN',
//     'ELECTION CARD',
//     'PM Kisan KYC',
//     'E Sharam Card',
//     'PM Ayushman Bharat Card',
//     'Aadhar',
//     'Other',
//   ];

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
